import React from 'react';
import { getInlineStyles, useResponsiveFontSize } from '../../stores/index.js';

const CustomStyledText = ({
    tag: Tag = 'span',
    styleConfig,
    className = '',
    style = {},
    children,
    innerTag,
    ...rest
}) => {
    const { fontSizeStyle, className: responsiveClass, styleText } = useResponsiveFontSize(styleConfig?.fontSize);

    if (!children) return null;

    const inlineStyles = getInlineStyles(styleConfig);

    let outerStyles = { ...inlineStyles, ...fontSizeStyle, ...style };
    let renderedChildren = children;

    // If there is a background color on the text style, apply it to an inline span
    // to mimic Word-style highlighting rather than filling the entire container.
    if (inlineStyles.backgroundColor) {
        const { backgroundColor, ...otherStyles } = inlineStyles;
        outerStyles = { ...otherStyles, ...fontSizeStyle, ...style };

        const highlightStyle = {
            backgroundColor,
            boxDecorationBreak: 'clone',
            WebkitBoxDecorationBreak: 'clone',
        };
        renderedChildren = <span style={highlightStyle}>{children}</span>;
    }

    return (
        <>
            {styleText && <style dangerouslySetInnerHTML={{ __html: styleText }} />}
            <Tag className={`${className} ${responsiveClass}`.trim()} style={outerStyles} tag={innerTag} {...rest}>
                {renderedChildren}
            </Tag>
        </>
    );
};

export default CustomStyledText;
